// extracted by mini-css-extract-plugin
export default {"onsiteInfo":"InfoTooltip_onsiteInfo__UqnKi","onsiteInfoTooltiptext":"InfoTooltip_onsiteInfoTooltiptext__frczX"};